import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import axios from "axios";
import ReuseableButton from "../../../components/Buttons/button";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { userColumns } from "./branchColumn";
let branchUrl = "https://arogyanxtdevapi.fundaclear.in/api/v1/Branch"

const BranchList = () => {
    const [loader, setLoader] = useState(false);
    const [branchList, setBranchList] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
        const fetchBranch = () => {
            setLoader(true)
            axios.get(branchUrl).then((res) => {
                if (res?.status === 200) {
                    setLoader(false)
                    setBranchList(res?.data?.result)
                }

            }).catch(err => console.log(err))
        }
        fetchBranch()
    }, [])
    const handleRouteBranchInfo = () => {
        navigate("/master/add-branch")
    }
    const handleGetRowId = (e) => {
        return e?.uniqueId
    }

    return (
        <>
            <div className='d-flex justify-content-end'>
                <div className="mr-5">
                    <ReuseableButton
                        text={"Add Branch"}
                        height={45}
                        colorVarient="success"
                        fullWidthFlag={true}
                        endIcon={<PersonAddAltIcon />}
                        handleChange={handleRouteBranchInfo}
                    />

                </div>
            </div>
            <div className="branch-table p-2">
                <DataGrid
                    autoHeight
                    rows={branchList && branchList?.length > 0 ? branchList : []}
                    loading={loader ? loader : false}
                    columns={userColumns}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={handleGetRowId}
                    checkboxSelection={false}
                />
            </div>
        </>
    )
};

export default BranchList